import { Button, DatePicker, message, Row, Table } from 'antd';
import FileSaver from "file-saver";
import { inject, observer } from "mobx-react";
import moment from 'moment';
import React, { Component } from 'react';
import Auth from "@/components/table/Auth";
import imgSave from "@/components/table/saveImg";
import dataDefault from './data';
import compute, { columns, } from "./compute";
import request from "@/method/request";
import _ from 'lodash'
import { sum } from "@/method";

@inject('store')
@observer
class index extends Component {
    state = {
        date: moment().format('YYYY-MM-DD'),
        data: [],
        loading: true,
        loadingSave: false,
        print: false,
        last: [],
        data4_1_1: []
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {
        const { date, last, data4_1_1 } = this.state;
        data = compute(data, { date, last, data4_1_1 });
        this.setState({ data, loading: false, });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getData = async (date) => {
        try {
            this.setState({ loading: true });
            let data = JSON.parse(JSON.stringify(dataDefault));
            const month = moment(date).format('M');
            const year = moment(date).format('YYYY');
            const day = moment(date).format('D');

            const x = await request(`/day4_2_3?year=${year}&month=${month}&day=${day}`);

            if (x.data.table && x.data.table.length > 0) {
                data = x.data.table.sort((a, b) => {
                    return a.sort - b.sort
                });
            }
            // 填充4.1.1数据至表格
            const _listName = ['best_rn', 'packges_rn', 'wholesale_rn', 'commerce_rn', 'discounts_rn'];
            const isFirstDay = moment(date).format('D') == 1; 
            if (isFirstDay) {

                const index = (moment(date).format('M') - 1) * 3;
                // 商务散客
                data[1].budget = sum(_listName.map(_x => _.get(x.data.data4_1_1, `${index}.${_x}`, 0)));
                data[1].forecast = sum(_listName.map(_x => _.get(x.data.data4_1_1, `${index + 1}.${_x}`, 0)));
                data[1].last = sum(_listName.map(_x => _.get(x.data.data4_1_1, `${index + 2}.${_x}`, 0)));
                // 休闲散客
                data[2].budget = sum(['corporate_rn', 'government_rn'].map(_x => _.get(x.data.data4_1_1, `${index}.${_x}`, 0)));
                data[2].forecast = sum(['corporate_rn', 'government_rn'].map(_x => _.get(x.data.data4_1_1, `${index + 1}.${_x}`, 0)));
                data[2].last = sum(['corporate_rn', 'government_rn'].map(_x => _.get(x.data.data4_1_1, `${index + 2}.${_x}`, 0)));

                // 商务团
                data[3].budget = _.get(x.data.data4_1_1, `${index}.business_rn`, 0);
                data[3].forecast = _.get(x.data.data4_1_1, `${index + 1}.business_rn`, 0);
                data[3].last = _.get(x.data.data4_1_1, `${index + 2}.business_rn`, 0);

                // 休闲团
                data[4].budget = _.get(x.data.data4_1_1, `${index}.leisure_rn`, 0);
                data[4].forecast = _.get(x.data.data4_1_1, `${index + 1}.leisure_rn`, 0);
                data[4].last = _.get(x.data.data4_1_1, `${index + 2}.leisure_rn`, 0);

                // 免费房
                data[9].budget = _.get(x.data.data4_1_1, `${index}.grand_rms`, 0);
                data[9].forecast = _.get(x.data.data4_1_1, `${index + 1}.grand_rms`, 0);
                data[9].last = _.get(x.data.data4_1_1, `${index + 2}.grand_rms`, 0);

                // 收益
                const _listNameRev = ['best_rev', 'packges_rev', 'wholesale_rev', 'commerce_rev', 'discounts_rev'];
                // 商务散客收益
                data[32].budget = sum(_listNameRev.map(_x => _.get(x.data.data4_1_1, `${index}.${_x}`, 0)));
                data[32].forecast = sum(_listNameRev.map(_x => _.get(x.data.data4_1_1, `${index + 1}.${_x}`, 0)));
                data[32].last = sum(_listNameRev.map(_x => _.get(x.data.data4_1_1, `${index + 2}.${_x}`, 0)));
                // 休闲散客
                data[33].budget = sum(['corporate_rev', 'government_rev'].map(_x => _.get(x.data.data4_1_1, `${index}.${_x}`, 0)));
                data[33].forecast = sum(['corporate_rev', 'government_rev'].map(_x => _.get(x.data.data4_1_1, `${index + 1}.${_x}`, 0)));
                data[33].last = sum(['corporate_rev', 'government_rev'].map(_x => _.get(x.data.data4_1_1, `${index + 2}.${_x}`, 0)));

                // 商务团
                data[34].budget = _.get(x.data.data4_1_1, `${index}.business_rev`, 0);
                data[34].forecast = _.get(x.data.data4_1_1, `${index + 1}.business_rev`, 0);
                data[34].last = _.get(x.data.data4_1_1, `${index + 2}.business_rev`, 0);

                // 休闲团
                data[35].budget = _.get(x.data.data4_1_1, `${index}.leisure_rev`, 0);
                data[35].forecast = _.get(x.data.data4_1_1, `${index + 1}.leisure_rev`, 0);
                data[35].last = _.get(x.data.data4_1_1, `${index + 2}.leisure_rev`, 0);
            }

            // 如果非当月第一天，填充预算、预测、去年数据
            if (x.data.last && x.data.last.length > 0 && day != 1) {
                data.forEach((item, i) => {
                    data[i].budget = _.get(x, `data.last.${i}.budget`, 0);
                    data[i].forecast = _.get(x, `data.last.${i}.forecast`, 0);
                    data[i].last = _.get(x, `data.last.${i}.last`, 0);
                });

            }

            this.setState({ last: x.data.last || [], data4_1_1: x.data.data4_1_1 || [] }, () => {
                this.computeNum(data, true);
            });
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    onSave = async () => {
        try {
            this.setState({ loadingSave: true });
            let date = this.state.date;
            if (!date) {
                message.error('请选择年份月份');
                let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                return
            }

            let year = moment(date).format("YYYY");
            let month = moment(date).format("M");
            let day = moment(date).format("D");
            let data = this.state.data.map((x, i) => ({ ...x, year, month, day, sort: i }));

            let dataFrom = new FormData();
            dataFrom.append('data', JSON.stringify(data));
            let headres = {
                method: 'post',
                credentials: 'include',
                headers: {},
                body: dataFrom
            }

            const x = await request('/saveDay4_2_3', headres);
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        } catch (err) {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('view4_1_5', 1.5, '4.23', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} 4.2.3 Early Bird Report`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_1_5').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, date, print, loading } = this.state;

        console.log(data);
        return (
            <div className="table7_1_1 tableHeight">
                <Row className="title" id="view4_1_5"  >
                    <Row>4.2.3 Early Bird Report</Row>
                    <Row className="table-month">
                        <DatePicker
                            placeholder="请选择年月"
                            monthCellContentRender={(date, local) => {
                                return moment(date).format('M月')
                            }}
                            defaultValue={moment(this.state.date, "YYYY-MM-DD")}
                            format="YYYY-MM-DD"
                            onChange={(date, str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                });
                                this.getData(str)
                            }}
                        />

                    </Row>
                    <Table
                        columns={columns(this.onChange, date, print)}
                        dataSource={data}
                        size="middle"
                        id="table4_1_5"
                        bordered
                        loading={loading}
                        pagination={false}
                        rowClassName="protruding"
                        className="content"
                        scroll={print ? {} : { y: 600 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadExcel();
                            });
                        }}
                        loading={print}
                    >导出Excel</Button>
                    <Auth loading={this.state.loading} auth="edit_4_2_3">
                        <Button
                            type="primary"
                            style={{ margin: '0 10px' }}
                            onClick={this.downloadSG}
                            loading={print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Auth>
                </Row>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.3/index.js